<div class="d-flex flex-column">
	<div style="max-width: 1300px">
		<div
			class="d-flex my-3 flex-row justify-content-end align-items-end gap-2 position-relative">
			<label
				class="text-tertiary text-center fw-semibold position-absolute top-50 start-50 translate-middle text-nowrap">
				{{ tituloRelatorio }}
			</label>
			<seira-select-list-menu
				[opcoes]="opcoesColunas"
				[opcoesSelecionadas]="colunasSelecionadas"
				[disabled]="carregandoRelatorio"
				[tituloBotao]="'Personalizar colunas'"
				(atualizarOpcoesSelecionadas)="setColunasSelecionadas($event)">
			</seira-select-list-menu>
		</div>

		<div
			*ngIf="carregandoRelatorio; else tabela"
			class="d-flex justify-content-center align-items-center w-100 h-50"
			style="min-height: 500px">
			<seira-loading [pageCentered]="false"></seira-loading>
		</div>

		<ng-template #tabela>
			<div
				style="max-width: 1300px"
				*ngIf="dadosTabelaPrecipitacaoAnual; else semDados">
				<seira-tabela-relatorio-pluv-anual-personalizada
					[relatorios]="dadosTabelaPrecipitacaoAnual"
					[colunasSelecionadas]="colunasSelecionadas" />
			</div>
		</ng-template>

		<seira-card-info aditionalClasses="mt-2 mb-4" [texto]="descricaoRelatorio" />
	</div>
</div>
<ng-template #semDados>
	<seira-sem-dados />
</ng-template>
